@if (label()) {
    <label [attr.for]="for() || null">
        {{ label() }}
        @if (optional()) {
            <span class="optional">· optioneel</span>
        }
    </label>
}
<ng-content></ng-content>
<ng-content select="[hint]"></ng-content>
